/* eslint-disable react/prop-types */
import React from 'react';
import {
  Form,
  Row,
  Col,
} from 'antd';
import { getModelPermission } from 'utils/permission';
import Select from '../../Select';
import IncidenciaAntiguedadParaEnfermedadGeneral from './IncidenciaAntiguedadParaEnfermedadGeneral';

const IncidenciasCatalogosAdicionales = ({
  form,
  idParent,
  rules,
  disabled,
  aplicaCatalogosAdicionales,
  setAplicaCatalogosAdicionales,
}) => {
  const handleAplicaCatalogosAdicionalesChange = (value) => {
    setAplicaCatalogosAdicionales(value);

    if (value === false) {
      form.setFieldValue('aplica_categorias_de_incapacidades', false);
      form.setFieldValue('aplica_subcategorias_de_incapacidades', false);
      form.setFieldValue('aplica_porcentaje_de_sueldo', false);
      form.setFieldValue('aplica_motivos_de_permisos', false);
    }
  };

  return (
    <Form
      layout="vertical"
      form={form}
      scrollToFirstError
      name="general"
      initialValues={{
        aplica_catalogos_adicionales: false,
        aplica_categorias_de_incapacidades: false,
        aplica_subcategorias_de_incapacidades: false,
        aplica_porcentaje_de_sueldo: false,
        aplica_motivos_de_permisos: false,
        aplica_antiguedad: false,
      }}
    >
      <Row gutter={10}>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="aplica_catalogos_adicionales"
            rules={rules.required}
            label="Aplican Catálogos Adicionales"
            hasFeedback
          >
            <Select
              trueFalse
              allowClear
              disabled={disabled}
              onChange={handleAplicaCatalogosAdicionalesChange}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="aplica_categorias_de_incapacidades"
            rules={rules.required}
            label="Aplica Categoría de Incapacidad"
            hasFeedback
          >
            <Select
              trueFalse
              allowClear
              disabled={disabled || !aplicaCatalogosAdicionales}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="aplica_subcategorias_de_incapacidades"
            label="Aplica Subcategoría de Incapacidad"
            rules={rules.required}
            hasFeedback
          >
            <Select
              trueFalse
              allowClear
              disabled={disabled || !aplicaCatalogosAdicionales}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="aplica_porcentaje_de_sueldo"
            label="Aplica Porcentaje de Pago de Sueldo"
            rules={rules.required}
            hasFeedback
          >
            <Select
              trueFalse
              allowClear
              disabled={disabled || !aplicaCatalogosAdicionales}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="aplica_motivos_de_permisos"
            label="Aplica Motivo de Permiso"
            rules={rules.required}
            hasFeedback
          >
            <Select
              trueFalse
              allowClear
              disabled={disabled || !aplicaCatalogosAdicionales}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Form.Item
            name="aplica_antiguedad"
            label="Aplica Antigüedad"
            hasFeedback
            rules={rules.required}
          >
            <Select
              trueFalse
              allowClear
              disabled={disabled}
            />
          </Form.Item>
        </Col>
        <Form.Item shouldUpdate>
          {({ getFieldValue }) => {
            const tipo = getFieldValue('aplica_antiguedad');
            return (
              <Row gutter={12}>
                {tipo === true && (
                  <Col xs={24} sm={24}>
                    <IncidenciaAntiguedadParaEnfermedadGeneral
                      permission={getModelPermission('incidenciaparametros')}
                      selected={idParent}
                      isEditable={false}
                    />
                  </Col>
                )}
              </Row>
            );
          }}
        </Form.Item>
      </Row>
    </Form>
  );
};

export default IncidenciasCatalogosAdicionales;
